import qs from 'querystringify'
import remote from './remote'

const URL = {
    ADD: '/cms/job',
    SEARCH: '/cms/job',
    DELETE: '/cms/job',
    UPDATE: '/cms/job'
}

export default {
    jobAdd (job, uploadProgressHandler) {
        return remote.request({
          url: remote.getUrl(URL.ADD),
          method: remote.METHOD.POST,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          data: job,
          timeout: 3600000,
          onUploadProgress: uploadProgressHandler,
        });
    },
    updateJob (contentId, job, uploadProgressHandler) {
        return remote.request({
            url: remote.getUrl(URL.UPDATE) + '/' + contentId,
            method: remote.METHOD.POST,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            data: job,
            timeout: 3600000,
            onUploadProgress: uploadProgressHandler
        })
    },
    searchJob (option) {
        let url = remote.getUrl(URL.SEARCH)

        if (option) {
            url = url + '?' + qs.stringify(option)
        }

        return remote.request({
            url: url
        })
    },
    searchJobDetail (contentId) {
        return remote.request({
            url: remote.getUrl(URL.SEARCH) + '/' + contentId,
            timeout: 30000,
        })
    },
    removeJob (contentId) {
        return remote.request({
            url: remote.getUrl(URL.DELETE),
            method: remote.METHOD.DELETE,
            headers: {
                'Content-Type': 'application/json'
            },
            data: Array.isArray(contentId) ? contentId : [contentId],
        })
    }
}
